// Classifies research_tasks.last_error into a badge kind.
// Pure, zero imports — backend/src/services/research/researchManager.js
// writes several NON-error codes into last_error (Issue 102 pacing, Tavily's
// own 432/433 month-exhausted answer, empty results, and since Issue 139 a
// cycle whose every result or finding the content scan withheld); only
// everything else is a real failure. See vault KNOWN_ISSUES Issue 124.

export const PACED_CODES = ['budget_paced', 'monthly_budget_exhausted', 'tavily_432'];
export const EMPTY_CODES = ['queries_empty', 'tavily_empty_results'];
// The search ran and returned text, but the content scan withheld all of it:
// every search result before analysis, or every finding before storage.
export const WITHHELD_CODES = ['enrichment_dropped_all', 'analysis_dropped_all'];

export function classifyLastError(lastError) {
  if (typeof lastError !== 'string') return null;
  const trimmed = lastError.trim();
  if (!trimmed) return null;
  if (PACED_CODES.includes(trimmed)) return { kind: 'paced', label: 'Paced' };
  if (EMPTY_CODES.includes(trimmed)) return { kind: 'empty', label: 'No results' };
  if (WITHHELD_CODES.includes(trimmed)) return { kind: 'withheld', label: 'Withheld' };
  return { kind: 'error', label: 'Error' };
}
